<p-datepicker
  [(ngModel)]="value"
  [minDate]="minDate"
  [maxDate]="maxDate"
  [dateFormat]="dateFormat"
  [showTime]="showTime"
  [showIcon]="false"
  [iconDisplay]="iconDisplay"
  [touchUI]="touchUI"
  [appendTo]="appendTo"
  [disabled]="disabled"
  (ngModelChange)="onModelChange($event)"
  [hideOnDateTimeSelect]="hideOnDateTimeSelect"
  class="rqa-calendar'"
  [firstDayOfWeek]="1"
  #calendar
>
  <ng-template pTemplate="footer">
    <div class="flex flex-column gap-2">
      @if (showTime) {
        <div class="flex align-items-center justify-content-center gap-2">
          <p-inputNumber
            [ngModel]="getHours()"
            (ngModelChange)="updateTime($event, 'hours')"
            [showButtons]="true"
            buttonLayout="vertical"
            [min]="0"
            [max]="23"
            [inputStyleClass]="'w-4rem p-1 text-sm text-center'"
            class="w-4rem"
          />
          <span>:</span>
          <p-inputNumber
            [ngModel]="getMinutes()"
            (ngModelChange)="updateTime($event, 'minutes')"
            [showButtons]="true"
            buttonLayout="vertical"
            [min]="0"
            [max]="59"
            [inputStyleClass]="'w-4rem p-1 text-sm text-center'"
            class="w-4rem"
          />
        </div>
      }
      @if (!hideOnDateTimeSelect) {
        <div class="flex justify-content-between">
          <p-button
            [label]="'buttons.cancel' | translate"
            [text]="true"
            icon="pi pi-times"
            size="small"
            (click)="onCancelCalendar()"
          ></p-button>
          <p-button
            [label]="'buttons.confirm' | translate"
            icon="pi pi-check"
            size="small"
            (click)="onConfirmCalendar()"
          ></p-button>
        </div>
      }
    </div>
  </ng-template>
</p-datepicker>
